
import RegisterForm from "../components/home/RegisterForm";

import { Helmet } from "react-helmet-async";


export default function Register() {
  return (
    <>
    <Helmet>
        <title>Register | MyApp</title>
      </Helmet>
<RegisterForm/>
   
    </>
  );
}
